import createReactComponent from '../createReactComponent';
export default createReactComponent('ladder', 'IconLadder', [
  ['path', { d: 'M8 3v18', key: 'svg-0' }],
  ['path', { d: 'M16 3v18', key: 'svg-1' }],
  ['path', { d: 'M8 14h8', key: 'svg-2' }],
  ['path', { d: 'M8 10h8', key: 'svg-3' }],
  ['path', { d: 'M8 6h8', key: 'svg-4' }],
  ['path', { d: 'M8 18h8', key: 'svg-5' }],
]);
